<!-- eslint-disable -->
<template>
  <div>
    <v-icon
      color="primary"
      v-if="drawer == true"
      @click.stop="drawer = false"
      x-large
      >mdi-chevron-double-right</v-icon
    >
    <v-icon
      color="primary"
      v-if="drawer == false"
      @click.stop="drawer = true"
      x-large
      >mdi-chevron-double-left</v-icon
    >
    <v-navigation-drawer
      :right="$i18n.locale == 'ar'"
      v-model="drawer"
      app
      class="drawer-with-background"
      color="primary"
    >
      <div class="d-flex justify-center align-center">
        <v-row class="ma-2 justify-center">
          <img class="ma-auto main-image" src="../assets/back3.jpg" />
          <h3 class="my-4">{{ $t("Notes Dashboard") }}</h3>
        </v-row>
      </div>
      <v-divider
        style="width: 90%; margin: auto; background-color: white"
      ></v-divider>
      <v-list rounded shaped>
        <div v-for="(item, index) in items" :key="index">
          <custom-item
            v-if="item.access.includes(adminType)"
            :item="item"
            @activate="activateItem"
          ></custom-item>
        </div>
      </v-list>
      <template v-slot:append>
        <v-list-item @click="logout" class="d-flex">
          <v-list-item-icon>
            <v-icon color="white">mdi-logout</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="text-white"
              ><span>{{ $t("logout") }}</span></v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-navigation-drawer>
  </div>
</template>

<script>
import customItem from "./customItem.vue";
import { Auth } from "@/store/auth";

export default {
  components: {
    customItem,
  },
  methods: {
    logout() {
      Auth.logout();
    },
  },
  data() {
    return {
      drawer: true,
      activeItem: null,

      items: [
        {
          title: "Courses",
          icon: "mdi-rename-box-outline",
          route: "/courses",
          access: ["super", "branch"],
        },
        {
          title: "Students",
          icon: "mdi-account-supervisor",
          route: "/students",
          access: ["super", "branch"],
        },
        {
          title: "Notes",
          icon: "mdi-notebook-multiple",
          access: ["super", "branch"],
          children: [
            {
              title: "multiNotes",
              icon: "mdi-note-multiple",
              route: "/multiNotes",
            },
            {
              title: "singleNotes",
              icon: "mdi-note",
              route: "/singleNotes",
            },
          ],
        },
        {
          title: "Types of notes",
          icon: "mdi-format-list-bulleted-type",
          route: "/TypeOfNotes",
          access: ["super", "branch"],
        },
        {
          title: "branches",
          icon: "mdi-source-branch",
          route: "/branches",
          access: ["super"],
        },
        {
          title: "admins",
          icon: "mdi-shield-crown-outline",
          route: "/admins",
          access: ["super"],
        },

        // { title: "support", icon: "mdi-forum", route: "/support" },
      ],
    };
  },
  computed: {
    adminType() {
      return localStorage.getItem("admin_type");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";
.center {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
}
.main-image {
  width: 50%;
}
.drawer-with-background {
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  span {
    color: white;
  }
}
</style>
